import { render } from "./MilestoneQuickAction.vue?vue&type=template&id=3a46ac7e"
import script from "./MilestoneQuickAction.vue?vue&type=script&lang=js"
export * from "./MilestoneQuickAction.vue?vue&type=script&lang=js"

import exportComponent from "/builds/sites/smolke/app-kwispelcoach-com/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__